import { ThemeProvider as ThemeProviderMaterialUI } from '@mui/material/styles';
import React from 'react';
import useCriteriaTheme from './useCriteriaTheme';
type Props = unknown;
const CriteriaThemeProvider: React.FC<React.PropsWithChildren<Props>> = ({
  children
}) => {
  const materialUiTheme = useCriteriaTheme();
  return <ThemeProviderMaterialUI theme={materialUiTheme}>{children}</ThemeProviderMaterialUI>;
};
export default CriteriaThemeProvider;